import { useState, useEffect } from 'react';

import { total } from '@/api/server/point/read';
import BigNumber from 'bignumber.js';
import { useUserInfo } from '@/store/zustand/store';
import { loginLocalStorage } from '@/lib/storage';
import { totalInAppBalance } from '@/api/server/inapp_payment/read';

export default function PointTotal() {
  const [point, setPoint] = useState('0');
  const userInfo = useUserInfo();
  useEffect(() => {
    // 인앱 결제 앱심사용 (실제 사용x)
    (async () => {
      if (userInfo.email === 'jh.koo@hupayx.com') {
        const re = await totalInAppBalance();
        if (re.ret_code !== 200) {
          return;
        }
        setPoint(BigNumber(re.data).toFormat());
      }
    })();
    return () => {};
  }, []);

  useEffect(() => {
    if (userInfo.level !== '3') {
      return;
    }
    (async () => {
      const re = await total();
      if (re.ret_code !== 200) {
        setPoint('0');
        return;
      }
      if (re.data.displayTotalPoint !== 0) {
        const total = BigNumber(re.data.displayTotalPoint).toFormat() ?? '0';
        setPoint(total);
      }
    })();
    return () => {};
  }, []);

  // const checkInAppTestAccount = async () => {
  //   if (loginLocalStorage().email === 'gen_member1') {
  //     return await totalInAppBalance();
  //     // setPoint((prev) => prev + '0');
  //   }
  // };

  return <>{point} P</>;
}
